export const EMPTY_STRING = ''
export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD'
export const DATE_SEPARATION = {
  amount: 6,
  type: 'months',
}
